import api from "./apiClient";

const apiCreateBillingPortalSession = async () => {
    const response = await api.post(
        "/api/captions/billing/create-customer-portal-session"
    );
    return response.data;
};

export default apiCreateBillingPortalSession;
